import { Star } from "lucide-react";

const SIZES = { xs: 11, sm: 13, md: 15 };

/**
 * First-party "Verified Trader Rating" — derived from FuturesFury's own Community
 * Pulse sentiment. NOT a third-party review-platform rating. Renders nothing when
 * the firm has insufficient data (rating absent).
 *
 * tone="dark"  → always-dark surfaces (firm cards, modals)
 * tone="auto"  → theme-aware surfaces (firm profile, SEO pages)
 */
export const VerifiedTraderRating = ({
  rating,
  count,
  tone = "auto",
  showLabel = true,
  size = "md",
}) => {
  if (!rating || rating <= 0) return null;
  const px = SIZES[size] || 15;
  const numClass = tone === "dark" ? "text-white" : "text-slate-900 dark:text-white";
  const subClass = tone === "dark" ? "text-slate-400" : "text-slate-500 dark:text-slate-400";
  const tip = `Verified Trader Rating — FuturesFury's own analysis of ${count || "recent"} public trader discussions over the last 30 days. Independent first-party signal, not sourced from any third-party review platform.`;
  return (
    <div className="flex items-center gap-1.5" data-testid="verified-trader-rating" title={tip}>
      <Star size={px} className="text-amber-400 fill-amber-400" />
      <span className={`text-sm font-bold ${numClass}`}>{Number(rating).toFixed(1)}</span>
      {showLabel && <span className={`text-xs ${subClass}`}>Verified Trader Rating</span>}
    </div>
  );
};
